<template>
  <div class="inline-block">
    <div
      class="flex flex-row items-center justify-start"
      :style="styling"
    >
      <slot name="prepend" />
      <slot name="icon">
        <FaSharpSolidCircleInfoSVG
          fill="currentColor"
          width="16"
          height="16"
        />
      </slot>
      <span :class="{ 'ml-4': hasIcon }">
        <slot name="default" />
      </span>
      <slot name="append" />
    </div>
  </div>
</template>

<script>
import FaSharpSolidCircleInfoSVG from '@fortawesome/fontawesome-pro/svgs/sharp-solid/circle-info.svg'

import spacing from '#tailwind-config/theme/spacing'
import colors from '#tailwind-config/theme/colors'
import borderRadius from '#tailwind-config/theme/borderRadius'

export default defineNuxtComponent({
  components: {
    FaSharpSolidCircleInfoSVG,
  },

  props: {
    color: {
      type: String,
      default: 'beige',
    },

    rounded: {
      type: String,
      default: '3xl',
    },

    py: {
      type: Number,
      default: 2,
    },

    px: {
      type: Number,
      default: 4,
    },

    noIcon: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasIcon () {
      return !!this.$slots?.icon || !this.noIcon
    },

    styling () {
      return {
        padding: `${spacing[this.py] || spacing[4]} ${spacing[this.px] ?? ''}`,
        background: colors[this.color],
        borderRadius: borderRadius[this.rounded],
      }
    },
  },
})
</script>
